module.exports = __webpack_public_path__ + "img/w77b.9c793d61.jpg";